// import React from 'react';

import axios from 'axios';
const BASE_URL = 'https://inventariosbackend.velasresorts.com/inventarios/qr';

const qrsApi = {
    crear: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/crear`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            // Validar retorno de array
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching informacion de creacion de qr:', error);
            return [];
        }
    },

    detalle: async (id: string) => {
        try {
            const response = await axios.get(`${BASE_URL}/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            // Validar retorno de array
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching informacion de qr:', error);
            return [];
        }
    },

    editar: async (id: string, qrActualizado: any) => {
        try {
            const response = await axios.get(`${BASE_URL}/editar/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            // Validar retorno de array
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching informacion de edicion de qr:', error);
            return [];
        }
    },

    listado: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/listado`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            // Validar retorno de array
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching qr:', error);
            return [];
        }
    },

    baja: async (id: string) => {
        try {
            const response = await axios.get(`${BASE_URL}/baja/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            // Validar retorno de array
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching informacion de baja de qr:', error);
            return [];
        }
    }
};

export default qrsApi;